import { render } from "./website_text.vue?vue&type=template&id=fd501fd4"
import script from "./website_text.vue?vue&type=script&lang=js"
export * from "./website_text.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__